import { getSavingsAccount } from '@/graphql/queries/banking/savings-account';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  const { code, provider, slug } = route.params;
  await $apolloQuery(getSavingsAccount, { code }).then(account => {
    if (account.slug !== slug || account.institution.slug !== provider) {
      return redirect(301, app.localePath(`/compare-savings-accounts/${account.institution.slug}/${account.code}/${account.slug}`));
    }
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const list = getListKeys(account).map(key => store.$i18n.t(`show.list.${key}`, { rate: store.$i18n.n(account.aer / 100, 'percent') }));
    const title = [account.institution.name, account.name].join(' ');

    store.commit('jumbotron/SET_JUMBOTRON', { list, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/banking', '/money/'], ['i18n/savings', '/compare-savings-accounts/'],
      ['i18n/providers', '/compare-savings-accounts/providers/', 'mobile'], [account.institution.name, `/compare-savings-accounts/${provider}/`],
      account.name
    ]);
    store.commit('pageContent/setHead', { title });
    store.commit('products/set', account);
  }).catch(_ => redirect(app.localePath('/compare-savings-accounts/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.savingNotFound') }));
};

const getListKeys = (account) => {
  const listKeys = [];
  if (account.childsaver) listKeys.push('child');
  if (account.account_type === 'TERM') listKeys.push('term');
  ['LUMP', 'REG'].forEach(type => {
    if (account.account_type.match(type)) listKeys.push(type.toLowerCase());
  });
  if (account.dirt_exempt) listKeys.push('dirtExempt');
  listKeys.push(`rate.${account.rate_type.toLowerCase()}`);
  return listKeys;
};
